/** Prefer centered avatar row for small mic-only calls (incl. 3-person groups). */
export const AVATAR_LAYOUT_MAX_PARTICIPANTS = 6;

/**
 * Compute equal tile width percentage so N tiles fit on one row without
 * wrapping when the panel is narrow (used by the video/tile grid fallback).
 */
export function computeTileWidthCss(
  count: number,
  minWidthPx: number,
  gapCss = "var(--gap-md)",
): string {
  const n = Math.max(1, count);
  const pct = Math.round(100 / n);
  return `min(max(${minWidthPx}px, ${pct}% - ${gapCss}), calc(${pct}% - ${gapCss}))`;
}

/**
 * Whether a small voice-only call should use the centered avatar row.
 */
export function shouldUseCenteredAvatarRow(options: {
  channelType: string | undefined;
  participantCount: number;
  hasFocus: boolean;
  hasActiveVideo: boolean;
}): boolean {
  if (options.hasFocus) return false;
  if (options.hasActiveVideo) return false;
  if (options.participantCount < 1) return false;

  if (options.channelType === "DirectMessage") return true;

  return (
    options.participantCount >= 2 &&
    options.participantCount <= AVATAR_LAYOUT_MAX_PARTICIPANTS
  );
}
